<ion-app [ngClass]="{ web: shared.web, 'app-shell-loading': loading }">
  <ion-router-outlet [ngClass]="{ blur: system.blur, 'behind-vinheta': loading }"></ion-router-outlet>
</ion-app>
